import { takeEvery, fork, put, all, call, select } from 'redux-saga/effects';

import { GET_REPORT_OPTIONS, GET_REPORT } from './actionTypes';
import {
    getReportOptionSuccess,
    getReportOptionFailed,
    getReportSuccess,
    getReportFailed
} from './actions';
import {noParamGet, paramGet} from '../../../apiHelpers/commonApiHelper';
import toastr from 'toastr';

function* getReportOptions() {
    try {
        const response = yield call(noParamGet, '/api/v1/players/all_players');
        if(response.status === 200) {
            yield put(getReportOptionSuccess(response.data));
        } else {
            yield put(getReportOptionFailed());
        }

    } catch (error) {
        yield put(getReportOptionFailed());
    }
}

function* getReports({payload}) {
    try {
        const response = yield call(paramGet, '/api/v1/players/get_reports', payload);
        if(response.status === 200) {
            yield put(getReportSuccess(response.data));
        } else {
            yield put(getReportFailed());
        }

    } catch (error) {
        yield put(getReportFailed());
    }
}

export function* watchGetReportOptions() {
    yield takeEvery(GET_REPORT_OPTIONS, getReportOptions)
}

export function* watchGetReports() {
    yield takeEvery(GET_REPORT, getReports)
}

function* reportSaga() {
    yield all([
        fork(watchGetReportOptions),
        fork(watchGetReports)
    ]);
}

export default reportSaga;